// Modo claro/oscuro persistido en localStorage (port de theme.js).
// El modo oscuro solo redefine variables CSS vía [data-theme="dark"].
const KEY = 'emy-theme';
type Theme = 'light' | 'dark';
const listeners = new Set<() => void>();

export function initTheme(): void {
  const guardado = (localStorage.getItem(KEY) as Theme | null) ?? 'light';
  document.documentElement.setAttribute('data-theme', guardado);
}

export function currentTheme(): Theme {
  return (document.documentElement.getAttribute('data-theme') as Theme) || 'light';
}

export function toggleTheme(): Theme {
  const t: Theme = currentTheme() === 'dark' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', t);
  localStorage.setItem(KEY, t);
  listeners.forEach((l) => l());
  return t;
}

export function subscribeTheme(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}
